<template>
  <div class="main i18n-batch-page">
    <div class="main_r">
      <div class="page-top">
        <div class="title_line">国际化批量管理</div>

        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field">
              <label class="filter-field__label">模块</label>
              <el-select v-model="queryData.entityType" placeholder="选择模块" @change="handleEntityTypeChange" size="small">
                <el-option v-for="(label, key) in entityTypeLabels" :key="key" :label="label" :value="key"></el-option>
              </el-select>
            </div>
            <div class="filter-field">
              <label class="filter-field__label">翻译状态</label>
              <el-select v-model="queryData.status" placeholder="翻译状态" size="small">
                <el-option label="全部" value="all"></el-option>
                <el-option label="未翻" value="none"></el-option>
                <el-option label="部分翻译" value="partial"></el-option>
                <el-option label="已完" value="complete"></el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--wide">
              <label class="filter-field__label">关键词</label>
              <el-input v-model="queryData.keyword" placeholder="请输入搜索关键词" size="small" clearable></el-input>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
            <span class="filter-strip__sep"></span>
            <el-button type="success" size="small" plain icon="el-icon-download" @click="downloadTemplate" :loading="downloadingTemplate">下载Excel模板</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-download" @click="exportExcel" :loading="exporting">导出Excel</el-button>
            <el-upload
              class="import-upload"
              action=""
              accept=".xlsx,.csv"
              :show-file-list="false"
              :http-request="importFile"
              :before-upload="beforeImportUpload">
              <el-button type="warning" size="small" plain icon="el-icon-upload" :loading="importing">导入Excel</el-button>
            </el-upload>
          </div>
        </div>
      </div>

      <!-- 数据表格 -->
      <div class="table-section">
        <div class="table-container">
          <el-table
            :data="dataList"
            class="i18n-table"
            :header-cell-style="{textAlign: 'center'}"
            :cell-style="{ textAlign: 'center' }"
            border>
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column label="模块" width="100">
              <template slot-scope="scope">
                <span>{{ entityTypeLabels[scope.row.entityType] || scope.row.entityType }}</span>
              </template>
            </el-table-column>
            <el-table-column label="源文" min-width="200">
              <template slot-scope="scope">
                <div class="source-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <span class="field-value">{{ (scope.row.sourceFields && scope.row.sourceFields[field.name]) || '-' }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="English" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations.en[field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Deutsch" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations.de[field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="繁體中文" min-width="220">
              <template slot-scope="scope">
                <div class="translation-fields">
                  <div v-for="field in getCurrentFields(scope.row)" :key="field.name" class="field-item">
                    <span class="field-label">{{ field.label }}:</span>
                    <el-input
                      size="small"
                      v-model="scope.row.translations['zh-Hant'][field.name]"
                      :placeholder="field.label"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                    ></el-input>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.status === 'complete'" type="success" size="small">已完成</el-tag>
                <el-tag v-else-if="scope.row.status === 'partial'" type="warning" size="small">部分翻译</el-tag>
                <el-tag v-else type="info" size="small">未翻译</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 分页 + 底部操作 -->
      <div class="pagination-wrapper">
        <el-button type="primary" size="small" icon="el-icon-check" @click="saveChanges" :loading="saving">保存当前页修改</el-button>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="page_size"
          layout="prev, pager, next, sizes, jumper"
          :total="dataListTotal">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default {
  name: 'I18nBatchManagement',
  data() {
    return {
      activeName: 'first',
      queryData: {
        entityType: 'ACTION',
        status: 'all',
        keyword: ''
      },
      dataList: [],
      originalData: [],
      dataListTotal: 0,
      page_no: 1,
      page_size: 10,
      saving: false,
      exporting: false,
      importing: false,
      downloadingTemplate: false,
      entityTypeLabels: {
        'ACTION': '动作库',
        'COURSE': '课程库',
        'TRAIN_PLAN': '训练计划',
        'GV': '字典',
        'NOTICE': '通知',
        'HELP_CENTER': '帮助中心',
        'REWARD': '奖品管理'
      },
      fieldConfig: {
        'ACTION': [
          { name: 'action_name', label: '动作名称' },
          { name: 'action_execution_point', label: '动作要领' },
          { name: 'action_respiratory_rate', label: '呼吸方法' },
          { name: 'action_sense', label: '动作感觉' },
          { name: 'action_error_correction', label: '易犯错误' }
        ],
        'COURSE': [
          { name: 'course_name', label: '课程名称' },
          { name: 'banner_title', label: '推荐标题' },
          { name: 'banner_description', label: '推荐描述' }
        ],
        'TRAIN_PLAN': [
          { name: 'train_plan_name', label: '计划名称' },
          { name: 'train_plan_info', label: '训练计划简介' },
          { name: 'banner_title', label: '推荐标题' },
          { name: 'banner_description', label: '推荐描述' }
        ],
        'GV': [
          { name: 'name', label: '名称' }
        ],
        'NOTICE': [
          { name: 'notice_title', label: '消息标题' },
          { name: 'notice_content', label: '消息内容' }
        ],
        'HELP_CENTER': [
          { name: 'question', label: '问题' },
          { name: 'answer', label: '回答' }
        ],
        'REWARD': [
          { name: 'reward_name', label: '奖品名称' },
          { name: 'description', label: '奖品描述' }
        ]
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    getCurrentFields(row) {
      const baseFields = this.fieldConfig[this.queryData.entityType] || []
      // 按 GV 类型，如果是协议/政策/须知类记录，额外显示 gv 字段
      if (this.queryData.entityType === 'GV' && row && row.sourceFields && row.sourceFields.name) {
        const name = row.sourceFields.name
        if (name.indexOf('协议') !== -1 || name.indexOf('政策') !== -1 || name.indexOf('须知') !== -1) {
          return [...baseFields, { name: 'gv', label: '内容' }]
        }
      }
      return baseFields
    },
    handleEntityTypeChange() {
      this.page_no = 1
      this.loadData()
    },
    clickQuery() {
      this.page_no = 1
      this.loadData()
    },
    clickQueryReset() {
      this.queryData = {
        entityType: 'ACTION',
        status: 'all',
        keyword: ''
      }
      this.page_no = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.page_size = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.loadData()
    },
    initTranslations(item) {
      if (!item.translations) {
        item.translations = {}
      }
      if (!item.translations.en) {
        item.translations.en = {}
      }
      if (!item.translations.de) {
        item.translations.de = {}
      }
      if (!item.translations['zh-Hant']) {
        item.translations['zh-Hant'] = {}
      }
      // 确保每个字段都有对应的 key
      const fields = this.getCurrentFields(item)
      fields.forEach(field => {
        if (item.translations.en[field.name] === undefined || item.translations.en[field.name] === null) {
          this.$set(item.translations.en, field.name, '')
        }
        if (item.translations.de[field.name] === undefined || item.translations.de[field.name] === null) {
          this.$set(item.translations.de, field.name, '')
        }
        if (item.translations['zh-Hant'][field.name] === undefined || item.translations['zh-Hant'][field.name] === null) {
          this.$set(item.translations['zh-Hant'], field.name, '')
        }
      })
    },
    loadData() {
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = this.queryData.entityType
      data.keyword = this.queryData.keyword
      data.status = this.queryData.status
      data.pageNo = this.page_no
      data.pageSize = this.page_size
      data.sign = Vue.prototype.FunGetSign(data)

      axios.get(Vue.prototype.global.Url_I18nSourceList, { params: data })
        .then(response => {
          if (response.data.code === 1) {
            var list = response.data.data.list || []
            list.forEach(item => {
              this.initTranslations(item)
            })
            this.dataList = list
            this.dataListTotal = response.data.data.total || 0
            // 深拷贝原始数据用于比较
            this.originalData = JSON.parse(JSON.stringify(this.dataList))
          } else {
            this.$message.error(response.data.msg || '加载失败')
          }
        })
        .catch(error => {
          Vue.prototype.FunRemindNetWorkError(error)
        })
    },
    checkTranslationChanged(item, original) {
      const languages = ['en', 'de', 'zh-Hant']
      const fields = this.getCurrentFields(item)
      for (let lang of languages) {
        for (let field of fields) {
          const currentVal = (item.translations[lang] && item.translations[lang][field.name]) || ''
          const originalVal = (original.translations[lang] && original.translations[lang][field.name]) || ''
          if (currentVal !== originalVal) {
            return true
          }
        }
      }
      return false
    },
    buildDownloadParams(includeStatus) {
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = this.queryData.entityType
      data.keyword = this.queryData.keyword
      if (includeStatus) {
        data.status = this.queryData.status
      }
      data.sign = Vue.prototype.FunGetSign(data)
      return data
    },
    beforeImportUpload(file) {
      const fileName = file.name ? file.name.toLowerCase() : ''
      const isXlsx = fileName.endsWith('.xlsx') || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const isCsv = fileName.endsWith('.csv') || file.type === 'text/csv' || file.type === 'application/vnd.ms-excel'
      const isSupported = isXlsx || isCsv
      const isLt20M = file.size / 1024 / 1024 < 20

      if (!isSupported) {
        this.$message.error('上传文件只能是Excel或CSV格式!')
      }
      if (!isLt20M) {
        this.$message.error('上传文件大小不能超过20MB!')
      }
      return isSupported && isLt20M
    },
    exportExcel() {
      const data = this.buildDownloadParams(true)
      const fileName = 'i18n-' + this.queryData.entityType + '-export.xlsx'
      this.downloadFile(Vue.prototype.global.Url_I18nExportXlsx, data, fileName, 'exporting')
    },
    downloadTemplate() {
      const data = this.buildDownloadParams(false)
      const fileName = 'i18n-' + this.queryData.entityType + '-template.xlsx'
      this.downloadFile(Vue.prototype.global.Url_I18nTemplateXlsx, data, fileName, 'downloadingTemplate')
    },
    downloadFile(url, params, fallbackName, loadingKey) {
      this[loadingKey] = true
      axios.get(url, {
        params: params,
        responseType: 'blob'
      }).then(response => {
        this[loadingKey] = false
        const fileName = this.getDownloadFileName(response.headers['content-disposition'], fallbackName)
        this.saveBlob(response.data, fileName)
      }).catch(error => {
        this[loadingKey] = false
        if (error.response && error.response.data instanceof Blob) {
          this.readBlobMessage(error.response.data, '下载失败')
          return
        }
        Vue.prototype.FunRemindNetWorkError(error)
      })
    },
    saveBlob(blob, fileName) {
      const url = window.URL || window.webkitURL
      const objectUrl = url.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = objectUrl
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      url.revokeObjectURL(objectUrl)
    },
    getDownloadFileName(disposition, fallbackName) {
      if (!disposition) {
        return fallbackName
      }
      const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1])
      }
      const normalMatch = disposition.match(/filename="?([^";]+)"?/i)
      if (normalMatch && normalMatch[1]) {
        return normalMatch[1]
      }
      return fallbackName
    },
    readBlobMessage(blob, fallbackMessage) {
      const reader = new FileReader()
      reader.onload = () => {
        this.$message.error(reader.result || fallbackMessage)
      }
      reader.readAsText(blob, 'utf-8')
    },
    importFile(option) {
      this.importing = true
      const signData = Vue.prototype.FunGetBaseSignData()
      signData.entityType = this.queryData.entityType
      signData.sign = Vue.prototype.FunGetSign(signData)

      const formData = new FormData()
      Object.keys(signData).forEach(key => {
        formData.append(key, signData[key])
      })
      formData.append('file', option.file)

      axios.post(Vue.prototype.global.Url_I18nImport, formData).then(response => {
        this.importing = false
        if (response.data.code === 1) {
          const info = response.data.data || {}
          this.$message.success('导入成功，共更新 ' + (info.translations || 0) + ' 个翻译')
          this.loadData()
          if (option.onSuccess) {
            option.onSuccess(response.data)
          }
        } else {
          this.$message.error(response.data.msg || '导入失败')
          if (option.onError) {
            option.onError(response.data)
          }
        }
      }).catch(error => {
        this.importing = false
        if (option.onError) {
          option.onError(error)
        }
        Vue.prototype.FunRemindNetWorkError(error)
      })
    },
    saveChanges() {
      const changedItems = []
      this.dataList.forEach((item, index) => {
        const original = this.originalData[index]
        if (this.checkTranslationChanged(item, original)) {
          changedItems.push({
            entityId: item.id,
            translations: item.translations
          })
        }
      })

      if (changedItems.length === 0) {
        this.$message.info('没有检测到修改')
        return
      }

      this.saving = true
      const requestBody = {
        entityType: this.queryData.entityType,
        items: changedItems
      }

      axios.post(Vue.prototype.global.Url_I18nBatchSave, requestBody, {
        headers: { 'Content-Type': 'application/json' }
      }).then(response => {
        this.saving = false
        if (response.data.code === 1) {
          this.$message.success('保存成功，共更新 ' + changedItems.length + ' 条数据')
          this.loadData()
        } else {
          this.$message.error('保存失败：' + (response.data.msg || '未知错误'))
        }
      }).catch(error => {
        this.saving = false
        Vue.prototype.FunRemindNetWorkError(error)
      })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  I18nBatchManagement · 运动主题设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.i18n-batch-page {
  /* 页面级 CSS 变量 */
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-warning-bg: #FFF8E6;
  --aptus-info: #5E6670;
  --aptus-info-bg: #F5F6F8;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  min-height: calc(100vh - 88px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main {
  display: flex;
}

.main_r {
  flex: 1;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field--wide {
  grid-column: span 1;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-field /deep/ .el-input,
.filter-field /deep/ .el-select {
  width: 100%;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  .import-upload {
    display: inline-block;
  }

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  margin-top: 12px;
}

.table-container {
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 翻译表格 */
.i18n-table {
  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

.source-fields,
.translation-fields {
  text-align: left;
  padding: 0 8px;
}

.field-item {
  margin-bottom: 8px;
}

.field-item:last-child {
  margin-bottom: 0;
}

.field-label {
  font-size: 12px;
  color: var(--aptus-text-muted);
  display: block;
  margin-bottom: 2px;
}

.field-value {
  font-size: 13px;
  color: var(--aptus-text);
  word-break: break-all;
}

.translation-fields .el-textarea {
  width: 100%;
}

/* 分页 + 底部操作 */
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 按钮颜色修正 */
/deep/ .el-button--success {
  color: #FFF !important;
  background-color: #2E7D32 !important;
  border-color: #2E7D32 !important;
}
/deep/ .el-button--success.is-plain {
  color: #2E7D32 !important;
  background-color: #EDF7ED !important;
  border-color: #A5D6A7 !important;
}
/deep/ .el-button--success.is-plain:hover,
/deep/ .el-button--success.is-plain:focus {
  color: #FFF !important;
  background-color: #2E7D32 !important;
  border-color: #2E7D32 !important;
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .i18n-batch-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr;
  }
}

</style>
